<template>
<!-- pc端 -->
<div class="mains-page" v-if="isSmallScreen===false">
  <div class="industry">
  <p class="indestry-lif">{{res1}} | Series Products</p>
  <p class="indestry-w">Why choose us</p>
</div>
<div class="indus">
  <p class="indus-chan" v-if="res1 !=='碳立方的优势'">产品简介  <span> Product introduction</span></p>
  <p class="i-p">{{res2}}</p>
  <p class="i-p">{{res3}}</p>
  <p class="indus-chan1" v-if="res1 !=='碳立方的优势'">案例简介  <span> Case introduction</span></p>
  <p class="i-p">{{res4}}</p>
</div>
<img class="kongpai" :src="require('@/assets/2023logoImage/' +formattedSrc)">
</div>
<!-- 移动端 -->
<div class="mains-page" v-else>
  <div class="industry">
  <p class="indestry-lif">{{res1}}</p>
  <p class="indestry-w">Why choose us</p>
</div>
<div class="indus">
  <!-- <p class="indus-chan" v-if="res1 !=='碳立方的优势'">产品简介  <span> Product introduction</span></p>
  <p class="i-p">{{res2}}{{res3}}</p> -->
  <p class="indus-chan1" v-if="res1 !=='碳立方的优势'">案例简介  <span> Case introduction</span></p>
  <p class="i-p">{{res4}}</p>
</div>
<img class="kongpai" src="../assets/brain/tlf_csltdn.png" alt="">
</div>
</template>
<script>
export default {
  props: {
    res1: {
      type: String,
      default: ''
    },
    res2: {
      type: String,
      default: ''
    },
    res3: {
      type: String,
      default: ''
    },
    res4: {
      type: String,
      default: ''
    },
    res5: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      formattedSrc: '',
      isSmallScreen: false
    }
  },
  created () {
    this.formattedSrc = this.res5.slice(24)
  },
  mounted () {
    this.formattedSrc = this.res5.slice(24)
    if (document.querySelector('body').offsetWidth < 1000) {
      this.isSmallScreen = true
    } else {
      this.isSmallScreen = false
      // var res = document.querySelector('.header-navbar')
      // if (res) {
      //   res.style.opacity = '0.5'
      // }
    }
  }
}
</script>
<style scoped lang="scss">
    .industry{
    text-align: center;
    margin-top:100px ;
    width: 100%;
    border-bottom: 1px solid #ececec ;
    .indestry-lif{
      font-size: 27px;
      font-weight: 500;
      margin-bottom: 10px ;
    }
    .indestry-w{
      color: #9a9a9a;
      margin-bottom: 20px;
    }
  }
  .indus{
    margin-top: 100px;
    // margin-left: 155px;
    margin-left:5%;
    margin-right: 5%;
    .indus-chan{
      font-size: 20px;
      font-weight: 600;
      margin-bottom: 40px;
      span{
        font-weight: 400;
        margin-left: 10px;
      }
    }
    .indus-chan1{
      margin-top: 73px;
      font-size: 20px;
      font-weight: 600;
      margin-bottom: 40px;
      span{
        font-weight: 400;
        margin-left: 10px;
      }
    }
    .i-p{
      font-size: 14px;
      color: #9a9a9a;
      margin-bottom: 14px;
    }
  }
  .kongpai{
    margin: 53px auto;
    // width: 1116px;
    width: 64%;
    // height: 691px;
  }
@media screen and (min-width: 1920px) {
    .industry{
    text-align: center;
    margin-top:100px ;
    width: 100%;
    border-bottom: 1px solid #ececec ;
    .indestry-lif{
      font-size: 27px;
      font-weight: 500;
      margin-bottom: 10px ;
    }
    .indestry-w{
      color: #9a9a9a;
      margin-bottom: 20px;
    }
  }
  .indus{
    margin-top: 100px;
    margin-left: 375px;
    .indus-chan{
      font-size: 20px;
      font-weight: 600;
      margin-bottom: 40px;
      span{
        font-weight: 400;
        margin-left: 10px;
      }
    }
    .indus-chan1{
      margin-top: 73px;
      font-size: 20px;
      font-weight: 600;
      margin-bottom: 40px;
      span{
        font-weight: 400;
        margin-left: 10px;
      }
    }
    .i-p{
      font-size: 16px;
      color: #9a9a9a;
      margin-bottom: 14px;
    }
  }
  .kongpai{
    margin: 53px auto;
    // width: 1155px;
    width: 64%;
    // height: 728px;
  }
}
@media screen and (max-width: 1440px) and (min-width:1000px) {
    .industry{
    text-align: center;
    margin-top:100px ;
    width: 100%;
    border-bottom: 1px solid #ececec ;
    .indestry-lif{
      font-size: 27px;
      font-weight: 500;
      margin-bottom: 10px ;
    }
    .indestry-w{
      color: #9a9a9a;
      margin-bottom: 20px;
    }
  }
  .indus{
    margin-top: 100px;
    // margin-left: 155px;
    margin-left:5%;
    margin-right: 5%;
    .indus-chan{
      font-size: 20px;
      font-weight: 600;
      margin-bottom: 40px;
      span{
        font-weight: 400;
        margin-left: 10px;
      }
    }
    .indus-chan1{
      margin-top: 73px;
      font-size: 20px;
      font-weight: 600;
      margin-bottom: 40px;
      span{
        font-weight: 400;
        margin-left: 10px;
      }
    }
    .i-p{
      font-size: 14px;
      color: #9a9a9a;
      margin-bottom: 14px;
    }
  }
  .kongpai{
    margin: 53px auto;
    // width: 1116px;
    width: 85%;
    // height: 691px;
  }
}
@media screen and (max-width: 1000px) and (min-width:768px) {
    .industry{
    text-align: center;
    margin-top:100px ;
    width: 100%;
    border-bottom: 1px solid #ececec ;
    .indestry-lif{
      font-size: 27px;
      font-weight: 500;
      margin-bottom: 10px ;
    }
    .indestry-w{
      color: #9a9a9a;
      margin-bottom: 20px;
    }
  }
  .indus{
    margin-top: 100px;
    // margin-left: 155px;
    margin-left:5%;
    margin-right: 5%;
    .indus-chan{
      font-size: 20px;
      font-weight: 600;
      margin-bottom: 40px;
      span{
        font-weight: 400;
        margin-left: 10px;
      }
    }
    .indus-chan1{
      margin-top: 73px;
      font-size: 20px;
      font-weight: 600;
      margin-bottom: 40px;
      span{
        font-weight: 400;
        margin-left: 10px;
      }
    }
    .i-p{
      font-size: 14px;
      color: #9a9a9a;
      margin-bottom: 14px;
    }
  }
  .kongpai{
    margin: 53px auto;
    // width: 1116px;
    width: 85%;
    height: 100%;
    // height: 691px;
    // height: 652px;
  }
}
@media screen and (max-width:375px) {
    .industry{
    text-align: center;
    margin-top:73px ;
    width: 100%;
    border-bottom: 1px solid #ececec ;
    .indestry-lif{
      font-size: 20px;
      font-weight: 700;
      margin-bottom: 10px ;
    }
    .indestry-w{
      margin-top:24px ;
      color: #9a9a9a;
      margin-bottom: 32px;
    }
  }
  .indus{
    margin-top: 10px;
    margin-left: 25px;
    margin-right: 25px;
    .indus-chan{
      margin-top:45px ;
      font-size: 16px;
      font-weight: 600;
      margin-bottom: 20px;
      span{
        font-weight: 400;
        margin-left: 10px;
      }
    }
    .indus-chan1{
      margin-top: 30px;
      font-size: 16px;
      font-weight: 600;
      margin-bottom: 40px;
      span{
        font-weight: 400;
        margin-left: 10px;
      }
    }
    .i-p{
      font-size: 14px;
      color: #9a9a9a;
      margin-bottom: 14px;
    }
  }
  .kongpai{
    margin: 23px,20px, 23px, 20px;
    width: 90%;
    // height: 348px;
    height: 100%;
  }
}
@media screen and (max-width:414px) and (min-width: 376px)  {
        .industry{
    text-align: center;
    margin-top:50px ;
    width: 100%;
    border-bottom: 1px solid #ececec ;
    .indestry-lif{
      font-size: 20px;
      font-weight: 700;
      margin-bottom: 10px ;
    }
    .indestry-w{
      margin-top:12px ;
      color: #9a9a9a;
      margin-bottom: 16px;
    }
  }
  .indus{
    margin-top: 10px;
    margin-left: 27px;
    margin-right: 25px ;
    margin-bottom:50px ;
    .indus-chan{
      margin-top:44px ;
      font-size: 16px;
      font-weight: 600;
      margin-bottom: 28px;
      span{
        font-weight: 400;
        margin-left: 12px;
      }
    }
    .indus-chan1{
      margin-top: 40px;
      font-size: 16px;
      font-weight: 600;
      margin-bottom: 28px;
      span{
        font-weight: 400;
        margin-left: 10px;
      }
    }
    .i-p{
      font-size: 14px;
      color: #9a9a9a;
      margin-bottom: 14px;
    }
  }
  .kongpai{
    margin: 23px,20px, 23px, 20px;
    width: 90%;
    // height: 319px;
    height: 100%;
  }
}
</style>
